import React, { useState, useEffect } from "react";

const ScrollMessageForm = ({ initialValue, onSubmit, onCancel }) => {
  const [message, setMessage] = useState("");

  useEffect(() => {
    setMessage(initialValue || "");
  }, [initialValue]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!message.trim()) return;
    onSubmit(message);
    setMessage("");
  };

  return (
    <section className="content container-fluid mt-4">
      <div className="row">
        <div className="col-lg-8 col-md-10 col-sm-12 col-xs-12 col-lg-offset-2 col-md-offset-1">
          <div className="box box-primary">
            <div className="box-header with-border d-flex justify-content-between align-items-center">
              <h3>{initialValue ? "Edit Scroll Message" : "Create Scroll Message"}</h3>
              <form onSubmit={handleSubmit}>
                <div className="form-group mb-3">
                  <textarea
                    rows="3"
                    className="form-control"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Enter scroll message..."
                  />
                </div>
                <div className="d-flex gap-2">
                  <button type="submit" className="btn btn-primary">
                    {initialValue ? "Update" : "Create"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={onCancel}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScrollMessageForm;
